import React from "react";
import {
  FiMessageSquare,
  FiMail,
  FiPhoneCall,
  FiBarChart2,
  FiLayers,
} from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import styles from "./Onboarding.module.css";

const SERVICES = [
  {
    key: "sms",
    icon: FiMessageSquare,
    title: "SMS",
    desc: "Send and receive text messages globally.",
  },
  {
    key: "email",
    icon: FiMail,
    title: "Email",
    desc: "Reliable transactional and marketing emails.",
  },
  {
    key: "voice",
    icon: FiPhoneCall,
    title: "Voice",
    desc: "Integrate voice calls and IVR systems.",
  },
  {
    key: "whatsapp",
    icon: FaWhatsapp,
    title: "WhatsApp",
    desc: "Engage customers on the world’s most popular messaging app.",
  },
  {
    key: "rcs",
    icon: FiMessageSquare,
    title: "RCS",
    desc: "Deliver rich, interactive business messages.",
  },
  {
    key: "flow",
    icon: FiLayers,
    title: "Flow",
    desc: "Build visual communication workflows.",
  },
  {
    key: "campaign",
    icon: FiMessageSquare,
    title: "Campaign",
    desc: "Manage and send large-scale campaigns.",
  },
  {
    key: "analytics",
    icon: FiBarChart2,
    title: "Analytics",
    desc: "Track and analyze communication performance.",
  },
];

const StepServices = ({ services, setServices, onBack, onFinish }) => {
  const toggle = (key) => {
    setServices((prev) =>
      prev.includes(key)
        ? prev.filter((k) => k !== key)
        : [...prev, key]
    );
  };

  return (
    <>
      <h1 className={styles.heading}>How do you plan to use Authkey?</h1>

      <p className={styles.subheading}>
        Select all the services you're interested in. We’ll tailor your setup
        accordingly.
      </p>

      <div className={styles.grid}>
        {SERVICES.map(({ key, icon: Icon, title, desc }) => (
          <div
            key={key}
            className={`${styles.serviceCard} ${
              services.includes(key) ? styles.active : ""
            }`}
            onClick={() => toggle(key)}
          >
            <div className={styles.iconBox}>
              <Icon size={18} />
            </div>

            <div>
              <h4>{title}</h4>
              <p>{desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.actionsBetween}>
        <button className={styles.secondaryBtn} onClick={onBack}>
          ← Back
        </button>

        <button
          className={styles.primaryBtn}
          disabled={!services.length}
          onClick={onFinish}
        >
          Finish Setup →
        </button>
      </div>
    </>
  );
};

export default StepServices;
